// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jfSn","title":"styles_title__20V3b"};